import { get } from 'lodash-es';
import { API_PREFIX } from '@/infrastructure/axios/code';
import AbstractHttpClient from '@/infrastructure/axios/request';
import { LoginType } from './tencent-cloud';

export interface LoginRequest {
  platform: LoginType
}

export type TencentCloudRequest = {
  saasToken: string;
  uin: string;
  ownerUin: string;
  p?: string;
};

export type IOARequest = {
  code: string;
};

export interface LoginTrpcRequest {
  baseParam: {
    platform: LoginType
  },
  qcloud?: TencentCloudRequest,
  tof?: IOARequest
}

export interface ChangeUserRequest {
  type: string;
  clientUA: string;
  // saas登录态
  token: string;
  tokenUin: string;
  tokenOwnerUin: string;
  tokenChangeUin: string;
  tokenChangeOwnerUin: string;
}

export class AuthService extends AbstractHttpClient {
  constructor() {
    super({});
  }

  public async login(loginType: LoginType, params: TencentCloudRequest | IOARequest) {
    try {
      const loginParams: LoginTrpcRequest = {
        baseParam: {
          platform: loginType,
        },
      };

      if (loginType === LoginType.TencentCloud) {
        loginParams.qcloud = params as TencentCloudRequest;
      } else {
        loginParams.tof = params as IOARequest;
      }

      const res = await this.client.post(`/${API_PREFIX}/api/login`, loginParams);

      const token = get(res, 'buglyToken');
      const userInfo = get(res, 'userInfo');

      if (token && userInfo) {
        return {
          buglyToken: token,
          userInfo,
        };
      }

      return null;
    } catch (e) {
      return null;
    }
  }

  public async sendSmsVerifyCode(phone: string) {
    try {
      await this.client.get(`/${API_PREFIX}/api/login/send-sms-code`, {
        params: {
          phone,
        },
      });

      return true;
    } catch (e) {
      return false;
    }
  }
}

export const authService = new AuthService();
